<template>
  <div
    id="idModalExample"
    class="modal-example-action-block">
    <h4 class="title">Example Data</h4>

    <div
      class="copy"
      @click="copyJson">
      <img
        :src="require('@/assets/icon/copy.svg')"
        width="10"
        class="m__r--2">
      Copy
    </div>

    <div class="container-data-json">
      <prism-editor
        v-model="example_data"
        :highlight="highlighter"
        :line-numbers="true"
        :readonly="true"
        class="my-editor"
      />
    </div>

    <b-form-row>
      <b-col md="12">
        <div class="d-flex justify-content-end">
          <div class="view-code">
            <textarea
              id="view-code"
              :value="example_data"/>
          </div>
          <button
            class="button-border m__t--10"
            @click="$emit('close')">
            Close
          </button>
        </div>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { highlight, languages } from 'prismjs/components/prism-core';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-sql';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  components: {
    PrismEditor,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      example_data: '',
    };
  },

  computed: {
  },

  watch: {
  },

  created() {
    if (this.columns && this.columns.length > 0) {
      const data = {};
      this.columns.map((e) => {
        let value = '';
        if (e.type === 'small_integer' ||
        e.type === 'integer' ||
        e.type === 'big_integer' ||
        e.type === 'float' ||
        e.type === 'decimal' ||
        e.type === 'number') {
          value = 0;
        } else if (e.type === 'boolean') {
          value = true;
        } else if (e.type === 'timestamp') {
          value = 1657683960000;
        }
        data[e.name] = value;
        return e;
      });
      this.example_data = `[\n ${JSON.stringify(data, null, 4).replace('}', ' }')}\n]`;
    }
  },

  methods: {
    highlighter(code) {
      return highlight(code, languages.js); // returns html
    },

    copyJson() {
      const codeToCopy = document.querySelector('#view-code');
      codeToCopy.setAttribute('type', 'text');
      codeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // eslint-disable-next-line
        this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Code was copied ' + msg);
      } catch (err) {
        // eslint-disable-next-line
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Oops, unable to copy');
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
    },
  },

  validations: {
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/ModalExampleActionBlock.vue